// planModules — what a tenant's PLAN takes away from its module list.
//
// plan_tiers.excluded_modules (mig 20261057700000) is a DENYLIST: the
// Compliance plan names what it leaves out, so a module shipped later appears
// on every plan without anyone editing a list. hasModule() and every nav
// surface already read ONE tenant cap (`enabledModules`, an allowlist), so the
// plan is folded into it here rather than threaded through ~10 call sites:
//
//   no exclusions            → the tenant's own cap, unchanged (Standard)
//   exclusions, no own cap   → every registered module minus the excluded
//   exclusions + own cap     → the own cap minus the excluded
//
// ⚠️ Browser-only, like the cap it narrows. The server stop for the money is
// the payroll_periods plan guard; RLS (has_perm) never reads either list.
import { ALL_MODULE_KEYS, resolveKey } from '@/lib/modules'

export function planCappedModules(
  enabledModules: string[] | null,
  excluded: readonly string[],
): string[] | null {
  if (excluded.length === 0) return enabledModules
  const out = new Set(excluded.map(resolveKey))
  const base = enabledModules && enabledModules.length > 0 ? enabledModules : ALL_MODULE_KEYS
  return base.filter(k => !out.has(resolveKey(k)))
}
